import { render, staticRenderFns } from "./ResourceTypesListPage.vue?vue&type=template&id=2403705f&"
import script from "./ResourceTypesListPage.vue?vue&type=script&lang=ts&"
export * from "./ResourceTypesListPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports